import { cn } from "@/lib/utils";

type CardProps = {
  children?: React.ReactNode;
  className?: string;
  subContainerClassName?: string;
  as?: React.ElementType;
  isHorizontal?: boolean;
};

function Card({
  children,
  className,
  subContainerClassName,
  as = "div",
  isHorizontal,
}: CardProps) {
  const Component = as;
  return (
    <Component
      className={cn("rounded-2xl border border-border bg-card", className)}
    >
      <div
        className={cn(
          "flex flex-1 flex-col",
          isHorizontal ? "flex-row" : "flex-col",
          subContainerClassName,
        )}
      >
        {children}
      </div>
    </Component>
  );
}

function CardHeader({
  title,
  description,
  children,
  className,
}: CardProps & {
  title?: React.ReactNode;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <header className={cn("-mb-1 p-4", className)}>
      {title && (
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      )}
      {description && (
        <p className="text-xs font-normal text-secondary">{description}</p>
      )}
      {children}
    </header>
  );
}

function CardContent({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "m-1 rounded-xl border border-border bg-background p-4 shadow-sm",
        className,
      )}
    >
      {children}
    </div>
  );
}

function CardFooter({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <footer className={cn("rounded-xl p-4", className)}>{children}</footer>
  );
}

Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Header = CardHeader;

export { Card };
